import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Home, Newspaper, Megaphone, BookUser, FolderOpen, PartyPopper, Construction } from "lucide-react";
import Journal from "./Journal";
import IntranetHome from "@/components/intranet/IntranetHome";
import IntranetNews from "@/components/intranet/IntranetNews";
import IntranetDirectory from "@/components/intranet/IntranetDirectory";
import IntranetResources from "@/components/intranet/IntranetResources";
import IntranetLife from "@/components/intranet/IntranetLife";

export const INTRANET_TABS = [
  { key: "accueil", label: "Accueil", icon: Home },
  { key: "wasagram", label: "WasaGram", icon: Newspaper },
  { key: "actualites", label: "Actualités", icon: Megaphone },
  { key: "annuaire", label: "Annuaire", icon: BookUser },
  { key: "ressources", label: "Ressources", icon: FolderOpen },
  { key: "vie", label: "Vie d'entreprise", icon: PartyPopper },
];

export default function Intranet() {
  const [sp, setSp] = useSearchParams();
  const section = useMemo(() => {
    const s = sp.get("section");
    if (s && INTRANET_TABS.some(t => t.key === s)) return s;
    if (sp.get("tab") || sp.get("chat") || sp.get("rituel") || sp.get("prefill")) return "wasagram";
    return "accueil";
  }, [sp]);

  const go = (key) => {
    const next = new URLSearchParams();
    next.set("section", key);
    setSp(next);
  };

  return (
    <div className="-m-4 sm:-m-6 min-h-full" style={{ background: "var(--bg-app)" }} data-testid="intranet-page">
      <div className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-slate-200" data-testid="intranet-tabs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center gap-1 overflow-x-auto">
          {INTRANET_TABS.map(t => (
            <button key={t.key} onClick={() => go(t.key)} data-testid={`intranet-tab-${t.key}`}
                    className={`relative flex items-center gap-2 px-4 py-3 text-sm font-semibold whitespace-nowrap border-b-2 transition-colors ${
                      section === t.key ? "border-[#1d4ed8] text-[#0b1b3a]" : "border-transparent text-slate-500 hover:text-slate-900"}`}>
              <t.icon className="w-4 h-4"/>{t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        {section === "accueil" && <IntranetHome go={go}/>}
        {section === "wasagram" && <Journal/>}
        {section === "actualites" && <IntranetNews go={go}/>}
        {section === "annuaire" && <IntranetDirectory go={go}/>}
        {section === "ressources" && <IntranetResources go={go}/>}
        {section === "vie" && <IntranetLife go={go}/>}
        {!["accueil", "wasagram", "actualites", "annuaire", "ressources", "vie"].includes(section) && <ComingSoon tab={INTRANET_TABS.find(t => t.key === section)}/>}
      </div>
    </div>
  );
}

function ComingSoon({ tab }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-16 text-center" data-testid={`intranet-coming-soon-${tab.key}`}>
      <div className="w-14 h-14 mx-auto rounded-lg bg-[#eef2ff] text-[#1d4ed8] grid place-items-center"><Construction className="w-7 h-7"/></div>
      <h2 className="mt-4 text-lg font-bold text-[#0b1b3a]">{tab.label}</h2>
      <p className="mt-1 text-sm text-slate-500">Contenu à venir — cet espace sera développé dans les prochaines étapes.</p>
    </div>
  );
}
